"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.ListArticle = ListArticle;
exports.UpdateArticle = UpdateArticle;
exports.UpdateStatus = UpdateStatus;
exports.autolistSkinForm = autolistSkinForm;
exports.changeStateSkinForm = changeStateSkinForm;
exports.checkActivityNewcomerPriceApi = checkActivityNewcomerPriceApi;
exports.deleteSkinForm = deleteSkinForm;
exports.detailSkinForm = detailSkinForm;
exports.exportSubmitSkinForm = exportSubmitSkinForm;
exports.generateRandomString = generateRandomString;
exports.getPidList = getPidList;
exports.getPidListPages = getPidListPages;
exports.getSkinDetailApi = getSkinDetailApi;
exports.getSkinFormList = getSkinFormList;
exports.saveSkinForm = saveSkinForm;
exports.saveSkins = saveSkins;
exports.userSubmitSkinForm = userSubmitSkinForm;
exports.userSubmitSkinFormHead = userSubmitSkinFormHead;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    name = _ref.name,
    status = _ref.status,
    page = _ref.page,
    limit = _ref.limit;
  var data = {
    name: name,
    status: status,
    page: page,
    limit: limit
  };
  return (0, _requestMapi.default)({
    url: '/mapi/product/web/activity/list',
    method: 'GET',
    params: data
  });
}
var handSubmit = function handSubmit() {
  var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var image = datas.image,
    name = datas.name,
    skuIds = datas.skuIds,
    status = datas.status;
  return {
    image: image,
    name: name,
    skuIds: skuIds,
    status: status
  };
};

/**
 * 新增
 * @param pram
 * @constructor
 */
function AddArticle(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/product/web/activity/save',
    method: 'post',
    data: handSubmit(pram)
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
function UpdateArticle(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/product/web/activity/update',
    method: 'post',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}
/**
 * 更新
 * @param pram
 * @constructor
 */
function UpdateStatus(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/product/web/activity/updateStatus',
    method: 'post',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}

/**
 * 删除
 * @param id
 * @constructor
 */
function DelArticle(pram) {
  var data = {
    id: pram.id
  };
  return (0, _requestMapi.default)({
    url: '/mapi/product/web/activity/delete',
    method: 'GET',
    params: data
  });
}
var titleMap = {
  3: '搜索框',
  1: '轮播图',
  2: '导航组',
  4: '图片魔方',
  5: '图片热区',
  6: '商品列表',
  7: '拼团商品',
  8: '促销列表'
};
var _handerSkinSubmit = function _handerSkinSubmit() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = JSON.parse(JSON.stringify(data)) || {},
    type = _ref2.type,
    config = _ref2.config,
    _ref2$componentList = _ref2.componentList,
    componentList = _ref2$componentList === void 0 ? [] : _ref2$componentList,
    miniAppId = _ref2.miniAppId,
    customerId = _ref2.customerId,
    id = _ref2.id;
  var configCustomerId = config && config.customerId != null && config.customerId !== '' ? config.customerId : null;
  var resolvedCustomerId = customerId != null && customerId !== '' ? customerId : configCustomerId;
  var nextConfig = Object.assign({}, config || {});
  if (resolvedCustomerId) {
    nextConfig.customerId = resolvedCustomerId;
  } else {
    delete nextConfig.customerId;
  }
  console.log('Debug - sending config data:', nextConfig);
  return {
    type: type,
    miniAppId: miniAppId,
    id: id,
    customerId: resolvedCustomerId || null,
    config: JSON.stringify(nextConfig),
    componentList: componentList.length && componentList.map(function (item) {
      var _ref3 = item || {},
        title = _ref3.title,
        showType = _ref3.showType,
        _ref3$settingInfo = _ref3.settingInfo,
        settingInfo = _ref3$settingInfo === void 0 ? {} : _ref3$settingInfo;
      return {
        title: title,
        showType: showType,
        settingInfo: JSON.stringify(settingInfo)
      };
    }) || []
  };
};
/**
 * 保存装修页
 */
function saveSkins(data) {
  return (0, _request.default)({
    url: '/admin/company-design/saveOrUpdate',
    method: 'POST',
    data: _handerSkinSubmit(data)
  });
}

/**
 * 详情
 */
function getSkinDetailApi(params) {
  var _this = this;
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/company-design/getDetail',
    method: 'GET',
    params: params
  }).then(function (res) {
    var _ref4 = res || {},
      type = _ref4.type,
      config = _ref4.config,
      componentList = _ref4.componentList,
      customerId = _ref4.customerId;
    var configInfo = {};
    try {
      configInfo = typeof config == 'string' ? JSON.parse(config) : config;
    } catch (error) {}
    ;
    if (customerId != null && customerId !== '') {
      configInfo = _objectSpread(_objectSpread({}, configInfo), {}, {
        customerId: Number(customerId)
      });
    }
    return {
      type: type,
      customerId: customerId,
      config: configInfo,
      componentList: componentList.length && componentList.map(function (item) {
        var _ref5 = item || {},
          showType = _ref5.showType,
          title = _ref5.title;
        var contentInfo = {};
        try {
          var value = item.settingInfo ? item.settingInfo : item.value;
          contentInfo = typeof value == 'string' && value ? JSON.parse(value) : value;
        } catch (error) {}
        ;
        var datas = _objectSpread(_objectSpread({
          itemKey: _this.generateRandomString(8)
        }, item), {}, {
          title: title || titleMap[showType],
          settingInfo: contentInfo
        });
        if (showType == 6 && !contentInfo.marketLists) {
          datas = _objectSpread(_objectSpread({}, datas), {}, {
            settingInfo: _objectSpread(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
              marketLists: [_objectSpread(_objectSpread({}, contentInfo), {}, {
                sourceType: contentInfo.sourceType ? contentInfo.sourceType : 1
              })],
              midPadding: 15,
              showType: 8,
              goodsPadding: {
                pt: 0,
                pb: 0,
                pl: 15,
                pr: 15,
                midP: 15
              },
              titleAlign: 'center'
            }, "showType", 2), "sortType", 1), "showTitle", 1), "showPrice", 1), "showPage", 1), "goodsShowType", 1), "pageLimit", 10), "titleColor", null), "bgImg", null), "bgColor", null), contentInfo)
          });
        }
        ;
        return datas;
      })
    };
  });
}
;

/**
 * 检查活动商品组件绑定SKU的新人价配置
 */
function checkActivityNewcomerPriceApi(params) {
  return (0, _request.default)({
    url: '/admin/customer-sku/newcomer-price/check',
    method: 'GET',
    params: params
  });
}
function generateRandomString(length) {
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var result = '';
  var charactersLength = characters.length;
  var usedStrings = new Set(); // 用于存储已生成的字符串，以确保唯一性

  function getRandomChar() {
    return characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  while (result.length < length) {
    result = ''; // 临时清空结果字符串
    for (var i = 0; i < length; i++) {
      result += getRandomChar();
    }
    // 检查生成的字符串是否已存在
    if (!usedStrings.has(result)) {
      usedStrings.add(result);
      break; // 如果唯一，则退出循环
    }
  }
  return result;
}

/**
 * 表单-列表
 */
function getSkinFormList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/order/web/dynamic-form/list',
    method: 'GET',
    params: params
  });
}

/**
 * 表单-删除
 */
function deleteSkinForm() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/order/web/dynamic-form/delete',
    method: 'post',
    params: params
  });
}

/**
 * 表单-修改状态
 */
function changeStateSkinForm() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/order/web/dynamic-form/status',
    method: 'post',
    params: params
  });
}

/**
 * 表单-保存
 */
function saveSkinForm() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/order/web/dynamic-form/save',
    method: 'post',
    data: data
  });
}

/**
 * 列表-详情
 */
function detailSkinForm() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/order/web/dynamic-form/detail',
    method: 'get',
    params: params
  });
}

/**
 * 列表-用户表单详情
 */
function userSubmitSkinForm() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var datas = _objectSpread({}, params);
  if (datas.dataRenage && datas.dataRenage.length) {
    var _ref6 = datas.dataRenage || [],
      _ref7 = _slicedToArray(_ref6, 2),
      startTime = _ref7[0],
      endTime = _ref7[1];
    datas['endTime'] = endTime;
    datas['startTime'] = startTime;
  }
  ;
  delete datas.dataRenage;
  return (0, _requestMapi.default)({
    url: '/mapi/order/web/dynamic-form/qa/list',
    method: 'get',
    params: datas
  });
}

/**
 * 列表-表头
 */
function userSubmitSkinFormHead() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/order/web/dynamic-form/qa/title',
    method: 'get',
    params: params
  });
}

/**
 * 表单导出
 */
function exportSubmitSkinForm() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/order/web/dynamic-form/qa/export',
    method: 'get',
    params: params
  });
}

/**
 * 表单下拉
 */
function autolistSkinForm() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/order/web/dynamic-form/select',
    method: 'get',
    params: params
  });
}

/**
 * 文字公告
 */
function getPidList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/category/list?pid=0&status=-1&type=3',
    method: 'get',
    params: params
  });
}

/**
 * 文章新闻
 */
function getPidListPages(cid) {
  return (0, _request.default)({
    url: "/admin/article/list?page=1&limit=20&cid=".concat(cid),
    method: 'get'
  });
}